import { LogOut, Settings } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLogout } from "@/features/auth";
import { cn, getNameInitials } from "@/lib/utils";

export const AvatarMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const loginId: string | undefined = undefined;
  const signout = useLogout();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={`User avatar for ${loginId ?? ""}`}
        className={cn(
          "flex h-10 w-10 pt-2 items-center justify-center rounded-full bg-foreground text-sm font-semibold text-primary-foreground",
          "focus-visible:outline-hidden focus-visible:ring-none"
        )}
      >
        <img
          src="/images/avatar.svg"
          alt=""
          className="h-full w-full aspect-ratio"
        />
        <span className="sr-only">{getNameInitials(loginId ?? "")}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {loginId && (
          <>
            <DropdownMenuLabel className="break-all text-xs font-normal text-muted-foreground">
              {loginId}
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuItem
          data-test-id="settings"
          onSelect={() => navigate("/settings")}
          className="cursor-pointer"
        >
          <Settings className="mr-2 h-4 w-4" />
          {t("settings")}
        </DropdownMenuItem>
        <DropdownMenuItem
          data-test-id="logout"
          onSelect={() => void signout()}
          className="cursor-pointer text-red-500 focus:text-red-500"
        >
          <LogOut className="mr-2 h-4 w-4" />
          {t("settings_logout")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
